import {DataStatus, Form, FormField} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useGetManufacturersQuery} from '@dms/api/core';
import {useGetWarehousesQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {
  getOptionsFromCustomersAsSupplier,
  getOptionsFromManufacturers,
  getOptionsFromWarehouses,
  useGetSupplierCustomersQuery,
} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

import {FormToDataGridConnectorProps} from 'features/eag-grid';

type ArticleUpdateJobMaterialModalListWarehouseTabExternalFiltersForm = Partial<{
  catalogNumber: string;
  warehouseId: string;
  manufacturerId: string;
  supplierId: string;
  isAvailable: boolean;
  isInStock: boolean;
}>;

type ArticleUpdateJobMaterialModalListWarehouseTabExternalFiltersProps =
  FormToDataGridConnectorProps & TestIdProps;

export function ArticleUpdateJobMaterialModalListWarehouseTabExternalFilters(
  props: ArticleUpdateJobMaterialModalListWarehouseTabExternalFiltersProps
) {
  const manufacturersQuery = useGetManufacturersQuery();

  const warehousesQuery = useGetWarehousesQuery();

  const suppliersQuery = useGetSupplierCustomersQuery();

  const isLoading =
    manufacturersQuery.isLoading || warehousesQuery.isLoading || suppliersQuery.isLoading;

  const isError = manufacturersQuery.isError || warehousesQuery.isError || suppliersQuery.isError;

  const values = {
    ...props.values,
  };

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      <Form<ArticleUpdateJobMaterialModalListWarehouseTabExternalFiltersForm>
        values={values}
        defaultValues={{}}
        onChange={props.onChange}
      >
        {(control) => (
          <VStack spacing={4}>
            <FormField
              control={control}
              name="catalogNumber"
              type="text"
              label={i18n.t('entity.warehouse.labels.catalogueNumber')}
              data-testid={suffixTestId('catalogueNumber', props)}
            />
            <FormField
              control={control}
              name="warehouseId"
              type="multiChoice"
              label={i18n.t('entity.warehouse.labels.warehouse')}
              options={getOptionsFromWarehouses(warehousesQuery.data)}
              data-testid={suffixTestId('warehouse', props)}
            />
            <FormField
              control={control}
              name="manufacturerId"
              type="multiChoice"
              label={i18n.t('entity.warehouse.labels.manufacturer')}
              options={getOptionsFromManufacturers(manufacturersQuery.data)}
              data-testid={suffixTestId('manufacturer', props)}
            />
            <FormField
              control={control}
              name="supplierId"
              type="multiChoice"
              label={i18n.t('entity.warehouse.labels.articleDefaultSupplier')}
              options={getOptionsFromCustomersAsSupplier(suppliersQuery.data)}
              data-testid={suffixTestId('supplier', props)}
            />
            <FormField
              control={control}
              name="isAvailable"
              label={i18n.t('entity.warehouse.labels.availableOnly')}
              type="checkbox"
              data-testid={suffixTestId('availableOnly', props)}
            />
            <FormField
              control={control}
              name="isInStock"
              label={i18n.t('entity.warehouse.labels.inStock')}
              type="checkbox"
              data-testid={suffixTestId('inStock', props)}
            />
          </VStack>
        )}
      </Form>
    </DataStatus>
  );
}
